import { safeJsonParse } from "./sharedHelper";

export const lsStorage = (key: string) => {
    return {
        getItem() {
            //@ts-ignore
            return safeJsonParse(window.localStorage.getItem(key));
        },
        removeItem() {
            window.localStorage.removeItem(key);
        },
        setItem(payload: any) {
            window.localStorage.setItem(key, JSON.stringify(payload));
        }
    };
};

export const ssStorage = (key: string) => {
    return {
        getItem() {
            //@ts-ignore
            return safeJsonParse(window.sessionStorage.getItem(key));
        },
        removeItem() {
            window.sessionStorage.removeItem(key);
        },
        setItem(payload: any) {
            window.sessionStorage.setItem(key, JSON.stringify(payload));
        }
    };
};

export const lsHasSeenDiscountModal = lsStorage("hasSeenDiscountModal");
export const lsJwt = lsStorage("jwt");
export const lsAccount = lsStorage("account");
export const lsBookingReference = lsStorage("bookingReference");
export const ssPathname = ssStorage("pathname");
export const ssTokenAuth = ssStorage("tokenAuth");
export const ssOrder = ssStorage("Order");
export const ssTokenAuthShare = ssStorage("tokenAuthShare");
export const lsEmail = lsStorage("lsEmail");
export const storageVersion = lsStorage("storageVersion");
